import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { withRouter } from 'react-router';
import I18n from 'i18n-js';
import * as PATH from '../../../../constants/routeConstants'; 
import EditInvoiceSupplierOverseaView from '../../../components/accounting/PayableInvoiceList/EditInvoiceSupplierOversea';
import ReceiptModal from '../../../components/accounting/PayableInvoiceList/ReceiptModal';
import * as actions from '../../../../actions/accounting/payable/editInvoiceSupplierOversea';
import * as selector from '../../../../selectors/accounting/payable/editInvoiceSupplierOversea';
import UploadTransferFileModal from '../../../components/accounting/PayableInvoiceList/UploadTransferFileModal';
import _ from 'lodash';
class EditInvoiceSupplierOversea extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            openReceiptModal: false,
            openTransferModal: false,
        })
    }

    componentWillReceiveProps(nextProps) {
        const {success, activeScreen} = nextProps;
        if(success) {
            nextProps.resetSuccessStatus();
            nextProps.router.history.push(PATH.ACCOUNTING_PAYABLE_INVOICE_URL)
            toastr.success(I18n.t('Notify.Success'), 'Update Invoice Success')
        }
        if(!activeScreen) {
            nextProps.router.history.goBack()
        }
    }

    openReceiptModal = () => {
        const {receiptFromInvoice} = this.props;
        this.props.createReceipt(receiptFromInvoice)
        this.setState({openReceiptModal: true})
    }

    closeReceiptModal = () => {
        this.props.changeEmptyReceipt()
        this.setState({openReceiptModal: false})
    }

    openTransferModal = () => {
        const {filesSaved} = this.props;
        this.props.copyFileToRawData(filesSaved);
        this.setState({openTransferModal: true})
    }

    closeTransferModal = () => {
        this.props.emptyFilesInRawData();
        this.setState({openTransferModal: false})
    }

    save = (paymentType, data) => {
        const {payAmount, amount} = this.props;
        if(payAmount == 0) {
            delete data.payment;
            this.props.save(paymentType, data);
        } else {
            data.payment.paid = payAmount;
            data.payment.paymentType = _.startCase(paymentType);
            this.props.save(paymentType, data, amount);
        }
    }

    render() {
        const {openReceiptModal, openTransferModal} = this.state;
        const { transferFiles, receiptData } = this.props;
        return (
            <span>
                <EditInvoiceSupplierOverseaView 
                    {...this.props} 
                    save = {(paymentType, data) => this.save(paymentType, data)}
                    openReceiptModal = {(value) => this.openReceiptModal(value)} 
                    openTransferModal = {() => this.openTransferModal()}
                />
                <ReceiptModal 
                    openModal = {openReceiptModal}
                    close = {this.closeReceiptModal}
                    receiptData = {receiptData}
                    changeReceiptValue = {(key, value) => this.props.changeReceiptValue(key, value)} 
                    onSubmitReceipt = {data => this.props.onSubmitReceipt(data)}
                />
                <UploadTransferFileModal
                    isOpen = {openTransferModal}
                    transferFiles = {transferFiles}
                    onClose = {this.closeTransferModal}
                    onAddFile = {file => this.props.onAddFile(file)}
                    onRemoveFile = {id => this.props.onRemoveFile(id)}
                    onSubmit = {(files) => this.props.onSubmitFiles(files)}
                />
            </span>
        );
    }
}

const mapStateToProps = state => ({
    constSupplierName: selector.getConstSupplierName(state),
    supplier: selector.getSupplier(state),
    issuedDate: selector.getIssuedDate(state),
    dueDate: selector.getDueDate(state),
    factor: selector.getFactor(state),
    paymentTerm: selector.getPaymentTerm(state),
    invoiceNo: selector.getInvoiceNo(state),
    creditDebit: selector.getCreditDebit(state),
    transactionNo: selector.getTransactionNo(state),
    listPaymentMethod: selector.getListPaymentMethod(state),
    paymentMethod: selector.getPaymentMethod(state),
    payAmount: selector.getPayAmount(state),
    paymentType: selector.getPaymentType(state),
    paid: selector.getPaid(state),
    amount: selector.getAmount(state),
    remaining: selector.getRemaining(state),
    listCheckablePurchaseOrder: selector.getListCheckablePurchaseOrder(state),
    editablePurchaseOrders: selector.getListPurchaseOrderDetail(state),
    transferFiles: selector.getTransferFiles(state),
    dataApi: selector.fnGenerateRequestData(state),
    filesSaved: selector.getFilesSaved(state),
    receiptData: selector.getReceiptDataFromRawData(state),
    receiptFromInvoice: selector.getReceiptFromInvoice(state),
    emptyReceipt: selector.getEmptyReceipt(state),
    success: selector.getSuccess(state),
    currencyTypeUSD: selector.getCurrencyTypeUSDOfSupplier(state),
    currencyTypeVND: selector.getCurrencyTypeVNDOfSupplier(state),
    disableChangeValue: selector.getDisableChangeValue(state),
    activeScreen: selector.getActiveScreenStatus(state),
    listCreditDebit: selector.getListCreditDebit(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    changeSupplier(value) {
        dispatch(actions.changeSupplier(value))
    },
    changeIssuedDate(value) {
        dispatch(actions.changeIssuedDate(value))
    },
    changeFactor(value) {
        dispatch(actions.changeFactor(value))
    },
    changeInvoiceNo(value) {
        dispatch(actions.changeInvoiceNo(value))
    },
    changeDueDate(value) {
        dispatch(actions.changeDueDate(value))
    },
    changeCreditDebit(value) {
        dispatch(actions.changeCreditDebit(value))
    },
    changeTransactionNo(value) {
        dispatch(actions.changeTransactionNo(value))
    },
    changePaymentMethod(data) {
        dispatch(actions.changePaymentMethod(data.value))
    },
    changePaymentType(value) {
        dispatch(actions.changePaymentType(value))
    },
    changePayAmount(value, remaining, paid) {
        dispatch(actions.changePayAmount(value, remaining, paid))
    },
    changeFilterPOText(value) {
        dispatch(actions.changeFilterPOText(value))
    },
    changeCheckedPurchaseOrder(item, checked) {
        dispatch(actions.changeCheckedPurchaseOrder(item._id, checked))
    },
    toggleActivePurchaseOrder(id, active) {
        dispatch(actions.toggleActivePurchaseOrder(id, active))
    },
    changePurchaseInvoiceNo(purchaseId, materialId, index, value) {
        dispatch(actions.changePurchaseInvoiceNo(purchaseId, materialId, index, value))
    },
    onAddFile(file) {
        dispatch(actions.addFileTransfer(file))
    },
    onRemoveFile(id) {
        dispatch(actions.onRemoveFile(id))
    },
    save(paymentType, data, totalAmount) {
        dispatch(actions.save(paymentType, data, totalAmount))
    },
    copyFileToRawData(files) {
        dispatch(actions.copyFileToRawData(files))
    },
    emptyFilesInRawData() {
        dispatch(actions.emptyFilesInRawData())
    },
    onSubmitFiles(files) {
        dispatch(actions.onSubmitFiles(files))
    },
    createReceipt(value) {
        dispatch(actions.createReceipt(value))
    },
    changeReceiptValue(key, value) {
        dispatch(actions.changeReceiptValue(key, value))
    },
    onSubmitReceipt(data) {
        dispatch(actions.onSubmitReceipt(data))
    },
    changeEmptyReceipt() {
        dispatch(actions.changeEmptyReceipt())
    },
    resetSuccessStatus() {
        dispatch(actions.resetSuccessStatus())
    }
})

export default connect(mapStateToProps, mapDispatchToProps) (withRouter(EditInvoiceSupplierOversea));